module.exports = __webpack_public_path__ + "static-portal/img/52-1.44e4bbb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/yingyong/52-1.jpg
// module id = /ux0
// module chunks = 4